import LicenseList from '../components/license/license-list';
import AddLicense from '../components/license/add-license';
import EditLicense from '../components/license/edit-license';
import CompanyList from '../components/company/company-list';
import AddCompany from '../components/company/add-company';
import UserList from '../components/user/user-list';
import AddUser from '../components/user/add-user';
import EditUser from '../components/user/edit-user';
import SignIn from '../components/auth/sign-in';
import NotFoundPageComponent from '../components/shared/not-found';

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/licenses',
    meta: {
      title: '',
      requiresAuth: true
    }
  },
  {
    path: '/licenses',
    name: 'licenses',
    component: LicenseList,
    meta: {
      title: 'Lizenzen',
      requiresAuth: true
    }
  },
  {
    path: '/add-license',
    name: 'add-license',
    component: AddLicense,
    meta: {
      title: 'Neue Lizenz',
      requiresAuth: true,
      parentRoute: 'licenses'
    }
  },
  {
    path: '/edit-license/:id',
    name: 'edit-license',
    component: EditLicense,
    meta: {
      title: 'Bearbeiten Lizenz',
      requiresAuth: true,
      parentRoute: 'licenses'
    }
  },
  {
    path: '/edit-user/:id',
    name: 'edit-user',
    component: EditUser,
    meta: {
      title: 'Benutzer bearbeiten',
      requiresAuth: true,
      parentRoute: 'users'
    }
  },
  {
    path: '/companies',
    name: 'companies',
    component: CompanyList,
    meta: {
      title: 'Kunden',
      requiresAuth: true
    }
  },
  {
    path: '/add-company',
    name: 'add-company',
    component: AddCompany,
    meta: {
      title: 'Neue Kunden',
      requiresAuth: true,
      parentRoute: 'companies'
    }
  },
  {
    path: '/users',
    name: 'users',
    component: UserList,
    meta: {
      title: 'Benutzer',
      requiresAuth: true
    }
  },
  {
    path: '/add-user',
    name: 'add-user',
    component: AddUser,
    meta: {
      title: 'Neuer Benutzer',
      requiresAuth: true,
      parentRoute: 'users'
    }
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: SignIn,
    meta: {
      title: 'Anmelden',
      requiresAuth: false,
      appHeaderHidden: true,
      appFooterDisplayed: true
    }
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'not-found',
    meta: {
      title: 'Nicht Gefunden',
      requiresAuth: false,
      showHeader: false
    },
    component: NotFoundPageComponent
  }
];

export default routes;
